<template>
  <div>
    <wisdom-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    >
    </wisdom-header>
    <wisdom-channel v-if="marketType == 'channel'"></wisdom-channel>
    <div v-html="marketData" v-if="marketType != 'channel'"></div>
    <wisdom-footer :bottom="bottom" :bottomInfo="bottomInfo"></wisdom-footer>
  </div>
</template>

<script>
import WisdomHeader from "@/components/mobile/Header";
import WisdomChannel from "@/components/mobile/WisdomChannel";
import WisdomFooter from "@/components/mobile/Footer";
export default {
  data() {
    return {
      marketData: "",
      topStyle: "",
      actIndex: 2,
      noLine: true,
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      about: {},
      culture: {},
      developList: [],
      teamList: [],
      partner: [],
      marketType: "",
      titleObj: {},
    };
  },
  mounted() {
    this.marketType = this.$route.params.type;
    this.Pc_Mobile();
    this.getPageData();
    switch (this.marketType) {
      case "case":
        this.titleObj = {
          title: "智慧案场",
          desc:
            "让房地产销售跳脱传统模式，不再受制于工程进度，将项目通过3D的方式提前呈现",
        };
        this.topStyle =
          "background:url('" +
          require("../../static/images/product/m_channel.png") +
          "')";
        break;
      case "spread":
        this.titleObj = {
          title: "智慧传播",
          desc: "专为企业打造官方营销入口，购房客户线上体验全面升级",
        };
        this.topStyle =
          "background:url('" +
          require("../../static/images/product/m_channel.png") +
          "')";
        break;
      case "channel":
        this.titleObj = {
          title: "智慧渠道",
          desc: "人脸识别判客规则和百度人脸识别技术有效结合",
        };
        this.topStyle =
          "background:url('" +
          require("../../static/images/product/m_channel.png") +
          "')";
        break;
    }
    this.getFreeData();
  },
  components: {
    WisdomHeader,
    WisdomChannel,
    WisdomFooter,
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_wisdomMarket/" + this.marketType);
      } else {
        this.$router.push("/wisdomMarket/" + this.marketType);
      }
    },
    getPageData() {
      this.$http.post("home/index/m_aboutpag", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        this.about = res.data.company[0];
        this.culture = res.data.culture[0];
        this.developList = res.data.develop;
        this.teamList = res.data.team;
        this.partner = res.data.partner;
        this.bottomInfo = res.data.contact[0];
      });
    },
    getFreeData() {
      let paramsId = 0;
      if (this.marketType == "case") {
        paramsId = 20;
      } else if (this.marketType == "spread") {
        paramsId = 19;
      }
      if (this.marketType != "channel") {
        this.$http.post(
          "https://eartisanapplets.wsandos.com/api/index/productdetail",
          { id: paramsId },
          (res) => {
            if (res.code == 1) {
              this.marketData = res.data.content;
            }
          }
        );
      }
    },

  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/mobile/WisdomMarket.vue